import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './application'
import './assets/scss/_main.scss'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App/>
  </StrictMode>,
)
